import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CATEGORIE_CANDIDATURA } from '../components/candidatura/validation';
import { REGION_LABELS } from '../components/italia3d/regionConfig';

const LANDING_PRESETS = {
  'olio-puglia': {
    categoria: 'Conserve',
    ruolo: 'produttore',
    titolo: 'Produttori di olio in Puglia',
    sottotitolo: 'Candidati per la categoria olio extravergine — selezione curata per territorio.',
  },
  caseifici: {
    categoria: 'Prodotti caseari',
    ruolo: 'produttore',
    titolo: 'Caseifici e produttori caseari',
    sottotitolo: 'Mozzarella, formaggi e latticini artigianali per il catalogo Mangitalia.',
  },
  logistica: {
    categoria: 'Logistica',
    ruolo: 'fornitore',
    titolo: 'Partner logistica e servizi',
    sottotitolo: 'Trasporti, packaging e integrazioni per la filiera alimentare.',
  },
};

const CATEGORIA_FROM_SLUG = {
  forno: 'Prodotti da forno',
  conserve: 'Conserve',
  caseari: 'Prodotti caseari',
  logistica: 'Logistica',
  altro: 'Altro',
};

export function resolveLandingPreset(slug) {
  return LANDING_PRESETS[slug] || null;
}

export function useCandidaturaDraftParams() {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const categoriaParam = searchParams.get('categoria');
    const categoriaSlug = searchParams.get('cat');
    const regione = searchParams.get('regione');
    const ruolo = searchParams.get('ruolo');
    const landing = searchParams.get('landing');
    const recupera = searchParams.get('recupera') === '1';

    let categoria = '';

    if (categoriaParam && CATEGORIE_CANDIDATURA.includes(categoriaParam)) {
      categoria = categoriaParam;
    } else if (categoriaSlug && CATEGORIA_FROM_SLUG[categoriaSlug]) {
      categoria = CATEGORIA_FROM_SLUG[categoriaSlug];
    } else if (landing && LANDING_PRESETS[landing]) {
      categoria = LANDING_PRESETS[landing].categoria;
    }

    const regioneLabel = regione && REGION_LABELS[regione] ? REGION_LABELS[regione] : null;

    return {
      categoria,
      regione,
      regioneLabel,
      ruolo,
      landing,
      preset: landing ? LANDING_PRESETS[landing] : null,
      recupera,
    };
  }, [searchParams]);
}

export { LANDING_PRESETS };
